import { useCallback, useEffect, useRef, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Link,
  Stack,
  Switch,
  Tab,
  Tabs,
  TextField,Chip, FormHelperText,
  Tooltip,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import FormPageHeader from "../utilities/FormPageHeader";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  checkFaxNumber,
  checkNumber,
  checkPhoneNumber,
  checkShortKey,
  checkString,
  checkUpparCaseOnly,
  emailValidation,
  isUrlValid,
} from "../utilities/FormValidation";
import AgGridTable from "../utilities/AgGridTable";
import * as Flags from "country-flag-icons/react/3x2";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import customStyles from "app/shared-components/SelectCustomStyle";
import CustomerDiscountData from "./tabs/DiscountData";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FinanceTab from "./tabs/FinanceTab";
import DocumentTab from "./tabs/DocumentTab";
import jwtDecode from "jwt-decode";
import { currencies } from "currencies.json";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";
import IconComponent from "app/shared-components/IconComponent";
import CustomerVendorRelation from "./tabs/CustomerVendorRelation";
import { toast } from "react-toastify";
import CreatableSelect from "react-select/creatable";
const routingOptions = [
  { value: "AB Delivery", label: "AB Delivery" },
  { value: "CommercialInvoice", label: "Commercial Invoice" },
  { value: "SOA", label: "SOA" },
  { value: "LogisticDocuments", label: "Logistic Documents" },
  { value: "SalesInvoice", label: "Sales Invoice" },
  { value: "MISREPORT", label: "MIS REPORT" },
  { value: "PIDelivery", label: "PI Delivery" },
  { value: "Forwarder Info Pending", label: "Forwarder Info Pending" },
];
const CustomerForm = () => {
  const [saving, setSaving] = useState(false);
  const savingRef = useRef(false);
  const [customerName, setCustomerName] = useState();
  const [customerNumber, setCustomerNumber] = useState();
  const [shortKey, setShortKey] = useState();
  const [partnerType, setPartnerType] = useState();
  const [country, setCountry] = useState();
  const [countryCode, setCountryCode] = useState();
  const [territory, setTerritory] = useState();
  const [emailId, setEmailId] = useState();
  const [currentEmail, setCurrentEmail] = useState(); 
  const [website, setWebsite] = useState();
  const [budgetCat, setBudgetCat] = useState();
  const [defaultContact, setDefaultContact] = useState();
  const [altContact, setAltContact] = useState();
  const [address1, setAddress1] = useState();
  const [address2, setAddress2] = useState();
  const [city, setCity] = useState();
  const [addcountryName, setAddcountryName] = useState();
  const [altaddress, setAltAddress] = useState(null);
  const [emailRouting, setEmailRouting] = useState([]);
  const [savedEmailRouting, setSavedEmailRouting] = useState([]);
  const [customerVendor, setCustomerVendor] = useState(null);
  const [saveCustomerVendor, setSaveCustomerVendor] = useState();
  const [saveEmailRouting, setSaveEmailRouting] = useState();
  const [poBox, setPoBox] = useState();
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
  const hubspotUrl= `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getPipelines}`;
  const [error, setError] = useState();
  const [rowData, setRowData] = useState([]);
  const [rowDataShowroom, setRowDataShowroom] = useState([]);
  const [selectedShowroomRows, setSelectedShowroomRows] = useState([]);
  const [showInMisReport, setShowInMisReport] = useState(false);
  const infoUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companyInfoes}`;
  const userURL = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}?size=1000`;
  const [financeId, setFinanceId] = useState();
  const [selectedEmailRows, setSelectedEmailRows] = useState([]);
  const formRef = useRef(null);
  const params = useParams();
  const [loading, setLoading] = useState(Boolean(params.id));
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);
  const [addCount, setAddCount] = useState(0);
  const [emailCount, setEmailCount] = useState(0);
  const [vendorCount, setVendorCount] = useState(0);
  const [countryOptions, setCountryOptions] = useState();
  const [territoryOptions, setTerritoryOptions] = useState();
  const [productTypeOptions, setProductTypeOptions] = useState();
  const [parterOptions, setParterOptions] = useState();
  const [orderTypeOptions, setOrderTypeOptions] = useState();
  const [userOptions, setUserOptions] = useState();
  const [userLists, setUserLists] = useState();
  const [validError, setValidError] = useState({});
  const [checksubmit, setCheckSubmit] = useState(false);
  const [active, setActive] = useState(false);
  const [caniasConnect,setCaniasConnect] = useState(false)
  const queryParam = new URLSearchParams(window.location.search);
  const [cityOptions, setCityOptions] = useState();
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [discountSuccessMsg, setDiscountSuccessMsg] = useState();
  const [financeSuccessMsg, setFinanceSuccessMsg] = useState();
  const [documentSuccessMsg, setDocumentSuccessMsg] = useState();
  const [discountError, setDiscountError] = useState();
  const [financeError, setFinanceError] = useState();
  const [customerError, setCustomerError] = useState();
  const [customerSuccessMsg, setCustomerSuccessMsg] = useState();
  const [documentError, setDocumentError] = useState();
  const [hideDelete, setHideDelete] = useState(true);
  const [saveDisable, setSaveDisable] = useState(true);
  const [saveEnableDisable, setSaveEnableDisable] = useState(true);
  const [saveOldEditData, setSaveOldEditData] = useState([]);
  const [editData, setEditData] = useState();
  const [gridApi, setGridApi] = useState(null);
  const [currencyList, setCurrencyList] = useState([]);
  const [hubspotSupported, setHubspotSupported] = useState(false);
  const [pipelineId, setPipelineId] = useState("");
  const [hubspotOrderStage, setHubspotOrderStage] = useState("");
  const [hubspotOrderPlacedStage, setHubspotOrderPlacedStage] = useState("");
  const gridRef = useRef();
  const [emailRoutingOption, setEmailRoutingOption] = useState(routingOptions);
  const [allUserList, setAllUserList] = useState([]);
  const [valueChangeTo, setValueChangeTo] = useState("");
  const [previousSelectedRows, setPreviousSelectedRows] = useState([]);
  const [saveOldData, setSaveOldData] = useState([]);
  const [savedEmailData, setSavedEmailData] = useState([]);
  const [hubspotData,setHubspotData]=useState([])
  const [pipelineOptions,setPipelineOptions] =useState([]);
  const [stageOptions, setStageOptions] = useState([]);
  const [editFinanceData, setEditFinanceData] = useState({
    telephone: "",
    fax: "",
    symbol: "EUR",
  });
  const [financeData, setFinanceData] = useState({
    telephone: "",
    fax: "",
    symbol: "EUR",
  });
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));
  const isIamOnly = Boolean(
    token?.scope?.includes("ROLE_IAM") &&
      !(
        token?.scope?.includes("ROLE_ADMIN") ||
        token?.scope?.includes("ROLE_SOPDIR")
      )
  );

  const ShowroomSwitch = (props) => {
    let bool = props?.data?.active;
    return (
      <Switch
        size="small"
        checked={bool}
        color="success"
        disabled
      />
    );
  };

  const [columnDefs, setColumnDefs] = useState([
    { field: "firstName", enableRowGroup: true },
    { field: "lastName", enableRowGroup: true },
    { field: "country", enableRowGroup: true },
    { field: "userName", enableRowGroup: true },
    { field: "roles", enableRowGroup: true },
    { field: "companyName", enableRowGroup: true },
    { field: "showroomName", enableRowGroup: true },
  ]);
  const [columnDefsShowroom, setColumnDefsShowroom] = useState([
    { field: "name", enableRowGroup: true, headerName: "Showroom Name" },
    { field: "region", enableRowGroup: true },
    { field: "active", enableRowGroup: true, cellRenderer: ShowroomSwitch, },
  ]);

  const EmailRoutingDropdown = forwardRef((props, ref) => {
    const { data, colDef, node } = props;
    const refEmailRouting = useRef();
    const [error, setError] = useState("");
    const [value, setValue] = useState("");

    const handleCountryChange = async (value) => {
      if (!value) return;
      props.node.setData(data);
      setValue(value);
      // setOpenCom(false);
      setEmailRouting((prev) =>
        [...prev]?.map((item) => {
          if (item.id === data.id) {
            return {
              ...item,
              emailRouting: value?.label,
            };
          } else {
            return { ...item };
          }
        })
      );
      setSelectedEmailRows([]);
    };

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value?.label;
        },
      };
    });
    useEffect(() => {
      if (data) {
        setValue(
          routingOptions?.filter(
            (item) =>
              item?.label?.toUpperCase() === data?.emailRouting?.toUpperCase()
          )[0]
        );
      }
    }, [data]);
    const selectWidth = document.querySelector(
      ".ag-cell-range-selected"
    )?.offsetWidth;
    return (
      <div className="w-full" style={{ width: selectWidth }}>
        <Select
          name="emailRouting"
          value={value}
          ref={refEmailRouting}
          onChange={handleCountryChange}
          className="select"
          classNamePrefix="select  min-h-0 !important"
          options={props?.options}
          styles={customStyles()}
          size="small"
          // isClearable
        />
      </div>
    );
  });

  const EmailFromDropdown = forwardRef((props, ref) => {
    const { data, colDef, node } = props;
    const refEmailRouting = useRef();
    const [error, setError] = useState("");
    const [value, setValue] = useState("");

    const handleCountryChange = async (value) => {
      if (!value) return;
      props.node.setData(data);
      setValue(value);
      setEmailRouting((prev) =>
        [...prev]?.map((item) => {
          if (item.id === data.id) {
            return {
              ...item,
              from: value.value,
            };
          } else {
            return { ...item };
          }
        })
      );
      setSelectedEmailRows([]);
    };

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value?.label;
        },
      };
    });
    useEffect(() => {
      if (data) {
        setValue(
          props?.userData?.filter((item) => item?.label === data?.from)[0]
        );
      }
    }, [data]);
    const selectWidth = document.querySelector(
      ".ag-cell-range-selected"
    )?.offsetWidth;

    return (
      <div className="w-full" style={{ width: selectWidth }}>
        <Select
          name="from"
          value={value}
          ref={refEmailRouting}
          onChange={handleCountryChange}
          className="select"
          classNamePrefix="select min-h-0 !important"
          options={props?.userData}
          styles={customStyles()}
          // isClearable
        />
      </div>
    );
  });
  const EmailToDropdown = forwardRef((props, ref) => {
    const { data, colDef, node } = props;
    setValueChangeTo(data);
    const refEmailRouting = useRef();
    const [error, setError] = useState("");
    const [value, setValue] = useState("");

    const handleCountryChange = async (value) => {
      if (!value) return;
      props.node.setData(data);
      setValue(value);
      setEmailRouting((prev) =>
        [...prev]?.map((item) => {
          if (item.id === data.id) {
            return {
              ...item,
              to: [...value?.map((i) => i.value)],
            };
          } else {
            return { ...item };
          }
        })
      );
      setSelectedEmailRows([]);
    };

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value?.map((data) => data.label);
        },
      };
    });
    useEffect(() => {
      if (data.to) {
        const list = data?.to;
        const check = props?.userData?.filter((item) =>
          list?.some((ftItem) => ftItem === item?.label)
        );
        setValue(check);
      }
    }, [data]);
    const selectWidth = document.querySelector(
      ".ag-cell-range-selected"
    )?.offsetWidth;

    return (
      <div className="w-full" style={{ width: selectWidth }}>
        <Select
          name="to"
          isMulti
          value={value}
          ref={refEmailRouting}
          onChange={handleCountryChange}
          className="select"
          classNamePrefix="select  min-h-0 !important"
          options={props?.userData}
          styles={customStyles()}
        />
      </div>
    );
  });
  const EmailCcDropdown = forwardRef((props, ref) => {
  const { data, userData, setUserData } = props;

  const [value, setValue] = useState([]);
  const [error, setError] = useState("");

  const handleCcChange = (selectedOptions) => {
  const updatedOptions = selectedOptions || [];

  setValue(updatedOptions);
  setError("");

  // Update main routing state
  setEmailRouting((prev) =>
    prev.map((item) =>
      item.id === data.id
        ? { ...item, cc: updatedOptions.map((i) => i.value) }
        : item
    )
  );

  setSelectedEmailRows((prev) =>
    prev.map((row) =>
      row.id === data.id
        ? { ...row, cc: updatedOptions.map((i) => i.value) }
        : row
    )
  );
};

  const handleCreate = (inputValue) => {
    const validationMessage = emailValidation(inputValue);

    if (validationMessage) {
      setError(validationMessage);
      return;
    }

    const newOption = { label: inputValue, value: inputValue };

    // Add to dropdown list if not exists
    if (!userData.some((u) => u.value === inputValue)) {
      setUserData([...userData, newOption]);
    }

    const updatedValue = [...value, newOption];
    setValue(updatedValue);
    handleCcChange(updatedValue);
  };

  useImperativeHandle(ref, () => ({
    getValue() {
      return value.map((item) => item.value);
    },
  }));

  useEffect(() => {
    if (data.cc) {
      const selectedEmails = data.cc.map(
        (email) =>
          userData.find((user) => user.value === email) || {
            label: email,
            value: email,
          }
      );
      setValue(selectedEmails);
    }
  }, [data, userData]);

  return (
    <div className="w-full">
      <CreatableSelect
        isMulti
        value={value}
        onChange={handleCcChange}
        onCreateOption={handleCreate}
         formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
        options={userData}
        className="select w-full"
        isClearable="false"
        classNamePrefix="select"
        styles={customStyles()}
        placeholder="Type email and press Enter..."
      />

      {error && (
        <p className="text-red-500 text-xs mt-1">{error}</p>
      )}
    </div>
  );
});
  // const EmailCcDropdown = forwardRef((props, ref) => {
  //   const { data, node, userData, setUserData } = props;
  //   const refEmailRouting = useRef();
  //   const [error, setError] = useState("");
  //   const [value, setValue] = useState([]);
  
  //   const handleCcChange = async (selectedOptions) => {
  //     if (!selectedOptions) return;
    
  //     setValue(selectedOptions);
    
  //     props.node.setData(data); 
    
  //     setEmailRouting((prev) =>
  //       [...prev]?.map((item) => {
  //         if (item.id === data.id) {
  //           return {
  //             ...item,
  //             cc: [...selectedOptions?.map((i) => i.value)],
  //           };
  //         } else {
  //           return { ...item };
  //         }
  //       })
  //     );
    
  //     setSelectedEmailRows([]); 
  //   };
  
  //   const handleCreateNewEmail = (inputValue) => {
  //     if (!inputValue.trim()) return;
  
  //     const exists = userData.some((user) => user.value === inputValue);
  //     if (!exists) {
  //       const newUser = { label: inputValue, value: inputValue };
  //       setUserData([...userData, newUser]); 
  //       handleCcChange([...value, newUser]); 
  //     }
  //   };
  
  //   useImperativeHandle(ref, () => ({
  //     getValue() {
  //       return value.map((item) => item.label);
  //     },
  //   }));
  
  //   useEffect(() => {
  //     if (data.cc) {
  //       const selectedEmails = data.cc.map((email) => {
  //         return userData.find((user) => user.value === email) || { label: email, value: email };
  //       });
  //       setValue(selectedEmails);
  //     }
  //   }, [data, userData]);
  
  //   const selectWidth = document.querySelector(".ag-cell-range-selected")?.offsetWidth;
  
  //   return (
  //     <div className="w-full" style={{ width: selectWidth }}>
  //       <Select
  //         name="cc"
  //         isMulti
  //         value={value}
  //         ref={refEmailRouting}
  //         onChange={handleCcChange}
  //         onInputChange={(input) => setError("")} // Clear errors while typing
  //         onBlur={(e) => handleCreateNewEmail(e.target.value)} // Add on blur
  //         onKeyDown={(e) => {
  //           if (e.key === "Enter") {
  //             e.preventDefault();
  //             handleCreateNewEmail(e.target.value);
  //           }
  //         }}
  //         className="select"
  //         classNamePrefix="select min-h-0 !important"
  //         options={userData}
  //         styles={customStyles()}
  //         placeholder="Type email and press Enter..."
  //       />
  //       {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
  //     </div>
  //   );
  // });
  // const EmailCcDropdown = forwardRef((props, ref) => {
  //   const { data, colDef, node } = props;
  //   const refEmailRouting = useRef();
  //   const [error, setError] = useState("");
  //   const [value, setValue] = useState("");

  //   const handleCountryChange = async (value) => {
  //     if (!value) return;
  //     props.node.setData(data);
  //     setValue(value);
  //     setEmailRouting((prev) =>
  //       [...prev]?.map((item) => {
  //         if (item.id === data.id) {
  //           return {
  //             ...item,
  //             cc: [...value?.map((i) => i.value)],
  //           };
  //         } else {
  //           return { ...item };
  //         }
  //       })
  //     );
  //     setSelectedEmailRows([]);
  //   };

  //   useImperativeHandle(ref, () => {
  //     return {
  //       getValue() {
  //         return value?.map((data) => data.label);
  //       },
  //     };
  //   });
  //   useEffect(() => {
  //     if (data.cc) {
  //       const list = data?.cc;
  //       const check = props?.userData?.filter((item) =>
  //         list?.some((ftItem) => ftItem === item?.label)
  //       );
  //       setValue(check);
  //     }
  //   }, [data]);
  //   const selectWidth = document.querySelector(
  //     ".ag-cell-range-selected"
  //   )?.offsetWidth;

  //   return (
  //     <div className="w-full" style={{ width: selectWidth }}>
  //       <Select
  //         name="cc"
  //         isMulti
  //         value={value}
  //         ref={refEmailRouting}
  //         onChange={handleCountryChange}
  //         className="select"
  //         classNamePrefix="select  min-h-0 !important"
  //         options={props?.userData}
  //         styles={customStyles()}
  //       />
  //     </div>
  //   );
  // });

const emailValidation = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email) ? "" : "Invalid email format";
};
const handleAreaManagerEmailChange = (data) => {
    const emails = data.map((row) => {
      return row.value;
    });
    setCurrentEmail(emails);
  };

  const selectedVal = emailRouting?.map((item) => item.emailRouting);

  const filteredRoutingOptions = routingOptions.filter(
    (element) => !selectedVal?.includes(element.label)
  );

  const [columnDefsEmail, setColumnDefsEmail] = useState([
    {
      field: "emailRouting",
      headerName: "*Email Routings",
      cellEditorPopup: true,
      cellEditor: EmailRoutingDropdown,
      cellEditorParams: {
        options: emailRoutingOption,
      },
    },
    {
      field: "from",
      headerName: "From",
      editable: (params) => params.data?.emailRouting !== "AB Delivery", 
      valueGetter: (params) => (params.data?.emailRouting === "AB Delivery" ? "orders@noltefze.com" : params.data?.from || ""), 
      valueSetter: (params) => {
        if (params.data?.emailRouting !== "AB Delivery") {
          params.data.from = params.newValue;
          return true;
        }
        return false;
      },
    },
    // {
    //   field: "from",
    //   cellEditorPopup: true,
    //   cellEditor: EmailFromDropdown,
    //   headerName: "From",
    //   cellEditorParams: {
    //     userData: allUserList,
    //   },
    // },
    // {
    //   field: "to",
    //   cellEditorPopup: true,
    //   cellEditor: EmailToDropdown,
    //   headerName: "*To",
    //   cellEditorParams: {
    //     userData: allUserList,
    //   },
    // },
    {
      field: "cc",
      headerName: "*CC",
      cellEditorPopup: true,
      cellEditor: EmailCcDropdown,
      cellEditorParams: {
        userData: allUserList,
        setUserData: setAllUserList,
      },
    },
  ]);

  const submitPartner = async () => {
    setCheckSubmit(true);
    let model = {
      name: customerName,
      shortKey: shortKey,
      customerNumber: customerNumber,
      id: customerNumber,
      territory: territory,
      emailId: emailId,
      website: website,
      defaultContact: defaultContact,
      defaultAddress: address1 && {
        tag: "default",
        address1: address1,
        address2: address2,
        poBox: poBox,
        city: city,
        country: addcountryName,
      },
      budgetOrderCategoryIds: budgetCat,
      countryName: country,
      countryCode: countryCode,
      customerType: partnerType,
      vendorCustomerRef: saveCustomerVendor,
      emailRoutings: emailRouting,
      alternateAddress: altaddress && altaddress,
      hubspotSupported: hubspotSupported,
      hubspotOrderStage: hubspotOrderStage,
      hubspotOrderPlacedStage: hubspotOrderPlacedStage,
      pipelineId: pipelineId,
      active: active,
      caniasConnect:caniasConnect,
      showInMisReport: showInMisReport,
      areaManager:currentEmail
    };
    const companyUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.company}`;
    const checkDuplicate = await OAuthService.getList(
      companyUrl + `/companiesByCustomerType?customerType=NOLTEFZE`
    );
    if (
      partnerType &&
      !validError.partnerType &&
      customerName &&
      !validError.customerName &&
      address1 &&
      city &&
      addcountryName &&
      country &&
      !validError.website &&
      !validError.email &&
      shortKey &&
      !validError.shortKey &&
      // hubspotSupported &&
      !validError.hubspotSupported 
      // hubspotOrderStage &&
      // !validError.hubspotOrderStage
    ) {
      try {
        if (params.id) {
          if (
            partnerType === "NOLTEFZE" &&
            checkDuplicate?.data?.result?.length > 0 &&
            checkDuplicate?.data?.result[0].id !== params.id
          ) {
            setError(
              "Multiple partners with partner type “NOLTEFZE“ are not allowed"
            );
          } else {
            if (
              financeData.telephone ||
              financeData.fax ||
              financeData.symbol
            ) {
              let financeObject = {
                ...financeData,
                companyId: `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}/${params.id}`,
              };
              if (financeId) {
                const updateData = await OAuthService.updateData(
                  infoUrl,
                  financeId,
                  financeObject
                );
              } else {
                const infUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companyInfo}`;
                const finance = await OAuthService.getList(
                  infUrl + `/getAdditionalDetail?companyId=${params.id}`
                );
                if (finance?.data && finance?.data?.id) {
                  const updateData = await OAuthService.updateData(
                    infoUrl,
                    finance?.data?.id,
                    financeObject
                  );
                } else {
                  const submitData = await OAuthService.addData(
                    infoUrl,
                    financeObject
                  );
                }
              }
            }
            await OAuthService.updateData(url, params.id, model);
            setSuccessMsg("Data Updated Successfully");
            setSnackState(true);
            await new Promise((resolve) => setTimeout(resolve, 800));
            navigate("/partners");
          }
        } else {
          const partner = await OAuthService.addData(url, model);
          if (partner?.data) {
            if (
              financeData.telephone ||
              financeData.fax ||
              financeData.symbol
            ) {
              let financeObject = {
                ...financeData,
                companyId: `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}/${partner.data.id}`,
              };
              if (financeId) {
                const updateData = await OAuthService.updateData(
                  infoUrl,
                  financeId,
                  financeObject
                );
              } else {
                const infUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companyInfo}`;
                const finance = await OAuthService.getList(
                  infUrl + `/getAdditionalDetail?companyId=${partner.data.id}`
                );
                if (finance?.data && finance?.data?.id) {
                  const updateData = await OAuthService.updateData(
                    infoUrl,
                    finance?.data?.id,
                    financeObject
                  );
                } else {
                  const submitData = await OAuthService.addData(
                    infoUrl,
                    financeObject
                  );
                }
              }
            }
            setSuccessMsg("Data saved Successfully");
            setSnackState(true);
            await new Promise((resolve) => setTimeout(resolve, 800));
            navigate("/partners");
          }
        }
      } catch (error) {
        if (partnerType === "NOLTEFZE" && error?.response?.status === 409) {
          setError(
            "Multiple partners with partner type “NOLTEFZE“ are not allowed"
          );
        } else {
          setError(error?.response?.data?.errorMessage || error.message);
        }
      }
    }
  };

  const runSaving = async (task) => {
    if (savingRef.current) return;
    savingRef.current = true;
    setSaving(true);
    try {
      return await task();
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
  };

  const handleSubmit = () => runSaving(submitPartner);
  const handleDelete = () => runSaving(deletePartner);
  const handleEmailSave = () => runSaving(submitEmailRouting);

  const handleFinanceDataChange = (fieldName, value, index) => {
    setFinanceData({ ...financeData, [fieldName]: value });
  };
  const onSelectCurrency = (data, action) => {
    setFinanceData({
      ...financeData,
      symbol: action.action === "clear" ? "" : data.value,
    });
  };

  const editPartner = async () => {
    try {
      const result = await OAuthService.getEditData(url, params.id);
      const customer = result?.data;

      if(customer?.emailRoutings && customer?.emailRoutings.length > 0){       
      setEmailRouting(
        customer?.emailRoutings?.map((items, index) => {
          return { ...items, id: index + 1 };
        })
      );
      // setSavedEmailData(customer?.emailRoutings?.map((items, index) => {
      //   return { ...items, id: index + 1 };
      // }))
      setSavedEmailData(JSON.parse(JSON.stringify(customer?.emailRoutings?.map((items, index) => {
        return { ...items, id: index + 1 };
      }))))
      setSaveOldData(JSON.parse(JSON.stringify(customer?.emailRoutings?.map((items, index) => {
        return { ...items, id: index + 1 };
      }))))
      setSavedEmailRouting(
        customer?.emailRoutings?.map((items, index) => {
          return { ...items, id: index + 1 };
        })
      );  
    }
      setCustomerName(customer?.name);
      setCurrentEmail(customer?.areaManager||[]);
      setCustomerNumber(params.id);
      setShortKey(customer?.shortKey);
      setTerritory(customer?.territory);
      if (customer?.territory && customer?.customerType !== "NOLTEFZE") {
        
        // const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${
        //   oAuthServiceConfig.territory
        // }/${customer?.territory.split(" ").pop()}/countries`;
        // const countries = await OAuthService.getList(url);
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}`;
   
        const list = await OAuthService.getList(
          url + `?sort=name,asc&size=1000`
        );
      

        const cntresult = list?.data?._embedded?.countries.map((value) => {
          const Flag = Flags[value.isoCode];
          return {
            label: value.name,
            value: value.name,
            code: value.isoCode,
            icon: value.isoCode && (
              <Flag width={18} style={{ marginInline: "5px" }} />
            ),
          };
        });
        setCountryOptions(cntresult);
      }
      setHubspotOrderStage(customer?.hubspotOrderStage);
      setHubspotOrderPlacedStage(customer?.hubspotOrderPlacedStage);
      setHubspotSupported(customer?.hubspotSupported);
      setPipelineId(customer?.pipelineId);
      setShowInMisReport(customer?.showInMisReport);
      setEmailId(customer?.emailId);
      setWebsite(customer?.website);
      setDefaultContact(customer?.defaultContact);
      setBudgetCat(customer?.budgetOrderCategoryIds);
      setCountry(customer?.countryName);
      setCountryCode(customer?.countryCode);
      const cityUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.cities}/citiesByCountryCode?countryCode=${customer?.countryCode}&size=1000`;
      const cities = await OAuthService.getList(cityUrl);

      const countryCity = cities?.data?.result?.map((value) => {
        return { label: value.text, value: value.text, id: value.id };
      });
      setCityOptions(countryCity);
      setActive(customer?.active);
      setCaniasConnect(customer?.caniasConnect );
      setPartnerType(customer?.customerType);
      setAddress1(customer?.defaultAddress?.address1);
      setAddress2(customer?.defaultAddress?.address2);
      setPoBox(customer?.defaultAddress?.poBox);
      setAddcountryName(customer?.defaultAddress?.country);
      setCity(customer?.defaultAddress?.city);
      if (customer?.alternateAddress !== null) {
        setAltAddress(customer?.alternateAddress);
        setAddCount(addCount + 1);
      }
      if (customer?.vendorCustomerRef !== null) {
        const relData = customer?.vendorCustomerRef.map((data, index) => {
          return { ...data, edit: false };
        });
        setSaveCustomerVendor(relData);
        setVendorCount(vendorCount + 1);
      }
      if (customer?.emailRoutings !== null) {
        const relData = customer?.emailRoutings?.map((data, index) => {
          return { ...data, edit: false };
        });
        setSaveEmailRouting(relData);
        setEmailCount(emailCount + 1);
      }
      setEditData(customer);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };
  const submitEmailRouting = async () => {
    if (!emailRouting || !emailRouting?.length) {
      toast.error("Please add at least one routing");
    } else {
      if (
        emailRouting?.some(
          (obj) =>
            !obj?.emailRouting ||
            // !obj?.from ||
            // !obj?.to || 
            // !obj?.to.length ||
            !obj?.cc ||
            !obj?.cc.length
        )
      ) {
        toast.error("Please fill all the fields");
      } else {
        const modifiedRowIds = new Set();

        try {
          let updatedData = [...savedEmailData];
          selectedEmailRows.forEach(selectedRow => {
              if (!modifiedRowIds.has(selectedRow.id)) {
                  const existingItemIndex = updatedData.findIndex(item => item.id === selectedRow.id);
                  if (existingItemIndex !== -1) {
                      updatedData[existingItemIndex] = { ...updatedData[existingItemIndex], ...selectedRow };
                  } else {
                      updatedData.push(selectedRow);
                  }
                  modifiedRowIds.add(selectedRow.id);
              }
          });
          setSavedEmailData(JSON.parse(JSON.stringify(updatedData)));
          setEmailRouting(updatedData);
          let model = {
              emailRoutings: updatedData,
          };
          const emailDataPromise = OAuthService.updateData(url, params.id, model);
          await Promise.all([emailDataPromise]);
          await editPartner();
      
          setSelectedEmailRows([]);
      
          toast.success("Routing saved successfully");
		  } catch (error) {
          setError(error.message);
        }
      }
    }
  };
  useEffect(() => {
    // First Condition
    let firstConditionSaveDisable = true;
    const selectedRow = {...selectedEmailRows[0]};

    if (selectedEmailRows && selectedEmailRows.length > 0) {
      if(selectedRow.hasOwnProperty('subject')) delete selectedRow.subject;
      const selectedEmailValues = Object.values(selectedRow);
      firstConditionSaveDisable = selectedEmailValues.map(v => {
        if(Array.isArray(v)) return !!v.length;
        return !!v
      }).some(v => v === false);
    }

    // Second Condition
    let secondConditionSaveDisable = !!saveOldData?.length;
    if (selectedEmailRows.length > 0 && saveOldData.length > 0) {
      const checkId = saveOldData.find((datas) => datas.id === selectedRow.id);
      const oldData = {
        emailRouting: checkId?.emailRouting || '',
        // from: checkId?.from || '',
        // to: checkId?.to || '',
        cc: checkId?.cc || '',
        id: checkId?.id || selectedRow.id,
      }
      const expectData = JSON.stringify(oldData) === JSON.stringify(selectedRow);
      secondConditionSaveDisable = expectData;
    }

    // Set saveDisable based on both conditions
    const saveDisable = selectedEmailRows.length > 0 ||firstConditionSaveDisable||secondConditionSaveDisable;
    setSaveEnableDisable(saveDisable);

    // Set previousSelectedRows
    setPreviousSelectedRows(selectedEmailRows);
  }, [selectedEmailRows, previousSelectedRows, saveOldData]);
 

  const checkFinanceData = async () => {
    try {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companyInfo}`;
      const finance = await OAuthService.getList(
        url + `/getAdditionalDetail?companyId=${params.id}`
      );
      if (finance?.data) {
        setFinanceId(finance?.data?.id);
        setFinanceData(finance?.data);
        setEditFinanceData(JSON.parse(JSON.stringify(finance?.data)));
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (params.id) {
      editPartner();
      setHideDelete(false);
      checkFinanceData();
    }
    if (currencies) {
      const list = currencies.map((curr) => {
        return { label: curr.name + " " + curr.code, value: curr.code };
      });
      setCurrencyList(list);
    }
  }, []);

  useEffect(() => {
    const selectedRoutes = emailRouting?.map((item) => item?.emailRouting);
    const check = routingOptions.filter(
      (item) =>
        !selectedRoutes?.some(
          (ftItem) =>
            ftItem?.toUpperCase()?.toString() ===
            item.label?.toUpperCase()?.toString()
        )
    );
    setEmailRoutingOption(check);
  }, [selectedEmailRows, emailRouting]);

  useEffect(() => {
    if (emailRoutingOption) {
      const clone = [...columnDefsEmail];
      clone?.map((item) => {
        if (item?.field === "emailRouting") {
          return (item.cellEditorParams.options = emailRoutingOption);
        }
      });
      setColumnDefsEmail(clone);
    }
    if (allUserList) {
      const clone = [...columnDefsEmail];
      clone?.map((item) => {
        if (
          // item.field === "from" ||
          // item.field === "to" ||
          item.field === "cc"
        ) {
          return (item.cellEditorParams.userData = allUserList);
        }
      });
      setColumnDefsEmail(clone);
    }
  }, [emailRoutingOption, allUserList]);

  const matchTwoArray = (a, b) => {
    return (
      a?.length === b?.length &&
      a?.every((e1) =>
        b?.some(
          (e2) =>
            e1?.emailRouting === e2?.emailRouting &&
            // e1?.from === e2?.from &&
            // e1?.to === e2?.to &&
            e1?.cc === e2?.cc
        )
      )
    );
  };
  /**
   * Tab Change
   */
  const handleTabChange = (event, value) => {
    setTabValue(value);
  };
  const handleAddCountryChange = (data) => {
    setAddcountryName(data.value);
  };
  const deletePartner = async () => {
    try {
      if (params.id) {
        const deleteCompany = await OAuthService.deleteData(url, params.id);
        setSuccessMsg("Data deleted Successfully");
        setSnackState(true);
      }
      await new Promise((resolve) => setTimeout(resolve, 800));
      navigate("/partners");
    } catch (error) {
      if (partnerType === "NOLTEFZE") {
        setError(
          'Deletion of Partner with Partner Type "NOLTEFZE" is not allowed'
        );
      } else {
        setError(error?.response?.data?.errorMessage || error.message);
      }
    }
  };

  useEffect(() => {
 
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}`;
      const Country = async () => {
        const list = await OAuthService.getList(
          url + `?sort=name,asc&size=1000`
        );
        let countries = list.data?._embedded?.countries.map((value) => {
          const Flag = Flags[value.isoCode];
          return {
            label: value.name,
            value: value.name,
            code: value.isoCode,
            icon: value.isoCode && (
              <Flag width={18} style={{ marginInline: "5px" }} />
            ),
          };
        });
        setCountryOptions(countries);
      };
      Country();
    
  }, [partnerType]);

  const handleCountryChange = async (data) => {
    setCountry(data.value);
    setCountryCode(data.code);
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.cities}/citiesByCountryCode?countryCode=${data.code}&size=1000`;
    const cities = await OAuthService.getList(url);

    const result = cities?.data?.result.map((value) => {
      return { label: value.text, value: value.text, id: value.id };
    });
    setCityOptions(result);

    setCity("");
  };
  const handleAddCityChange = async (data) => {
    setCity(data.value);
    const countryChange = await OAuthService.getList(
      `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.cities}/${data.id}/country`
    );
    setAddcountryName(countryChange?.data?.name);
  };
  const handleDefaultContact = (data, action) => {
    setDefaultContact(action.action === "clear" ? "" : data.value);
  };
  const handleAltContact = (data) => {
    setAltContact(data.value);
  };
  const handlePartnerChange = (data) => {
    // const roles = value.map((row) => {
    //     return row.value
    // });
    setPartnerType(data.value);
  };
  const handleTerritoryChange = async (data, action) => {
    setTerritory(action.action === "clear" ? "" : data.id);
  //   if (partnerType !== "NOLTEFZE") {
  //     const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}`;
  //  const list = await OAuthService.getList(
  //         url + `?sort=name,asc&size=1000`
  //       );
  //     const result = list?.data?._embedded.countries.map((value) => {
  //       const Flag = Flags[value.isoCode];
  //       return {
  //         label: value.name,
  //         value: value.name,
  //         code: value.isoCode,
  //         icon: value.isoCode && (
  //           <Flag width={18} style={{ marginInline: "5px" }} />
  //         ),
  //       };
  //     });
  //     setCountryOptions(result);
  //     setCountry("");
  //   }
  };

  useEffect(() => {
    const getNextSeqOfNum = async () => {
      if (!params.id) {
        try {
          const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.company}/nextSeqNumOfCompany`;
          const nextSeqNumOfCompany = await OAuthService.getList(url);
          setCustomerNumber(nextSeqNumOfCompany.data);
        } catch (error) {}
      }
    };
    getNextSeqOfNum();

    const territories = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.territory}?size=100`;
      const territories = await OAuthService.getList(url);

      const result = territories?.data?._embedded.territories.map((value) => {
        return {
          label: value.displayName,
          value: value.displayName,
          id: value?.id,
        };
      });
      setTerritoryOptions(result);
    };
    territories();
    const productType = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}?size=100`;
      const factoryVendor = await OAuthService.getList(url);

      const result = factoryVendor?.data?._embedded?.factoryVendors.map(
        (value) => {
          return { label: value.name, value: value.name };
        }
      );
      setProductTypeOptions(result);
    };
    productType();
    const orderType = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orderCategories}?size=100`;
      const orderCategories = await OAuthService.getList(url);

      const result = orderCategories?.data?._embedded?.orderCategories.map(
        (value) => {
          return { label: value.name, value: value.name };
        }
      );
      setOrderTypeOptions(result);
    };
    orderType();
    const users = async () => {
      const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;
      const user = await OAuthService.getList(
        url + `/search/findByCompanyId?companyId=${params.id}`
      );
      const nolteuser = await OAuthService.getList(
        url + `/search/findByCompanyId?companyId=1`
      );
      const allUsers = [
        ...nolteuser?.data?._embedded?.users,
        ...user?.data?._embedded?.users,
      ];
      const result = allUsers.map((value) => {
        const lastName = value?.lastName ? value.lastName : "";
        const middleName = value?.middleName ? value.middleName : "";
        const firstName = value?.firstName ? value.firstName : "";
        const name =
          firstName +
          " " +
          middleName +
          " " +
          lastName +
          " (" +
          value.userName +
          ")";
        return { label: name, value: value.firstName };
      });
      setUserLists(allUsers);
      setUserOptions(result);
    };
    users();
    const partnerOpt = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.company}/getcustomerTypes?size=100`;
      const partners = await OAuthService.getList(url);

      const result = partners?.data.map((value) => {
        return { label: value, value: value };
      });
      setParterOptions(result);
    };
    partnerOpt();
    // const cityOpt = async () => {
    //     const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.cities}?size=1000`;
    //     const cities = await OAuthService.getList(url);

    //     const result = cities?.data?._embedded?.cities.map((value) => {
    //         return { label: value.cityName, value: value.cityName, id: value._links.city.href.split('/').pop() }
    //     })
    //     setCityOptions(result);
    // }
    // cityOpt();
    const getUserList = async () => {
      const userData = await OAuthService.getList(userURL);
      setAllUserList(
        userData?.data?._embedded?.users?.map((option) => {
          return { value: option.email, label: option.email };
        })
      );
    };
    getUserList();
  }, []);

  const users = async () => {
    if (params.id) {
      const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByCompanyId?companyId=${params.id}`;
      const users = await OAuthService.getList(url);
      const userList = users.data?._embedded.users;
      setRowData(userList);
    }
  };

  const onGridReady = useCallback((params) => {
    users();
    setGridApi(params.api);
  }, []);
 
  const showroom = async () => {
    if (params.id) {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}/${params.id}/showrooms`;
      const showrooms = await OAuthService.getList(url);
      const showroomList = showrooms.data?._embedded?.showrooms;

      setRowDataShowroom(showroomList);
    }
  };

  const onGridShowroomReady = useCallback((params) => {
    showroom();
  }, []);

  const handleBudgetCatChange = (data) => {
    const cats = data.map((row) => {
      return row.value;
    });
    setBudgetCat(cats);
  };

  const handleActiveChange = (e) => {
    setActive(e.target.checked);
  };
  const handleCaniasConnectChange = (e) => {
    setCaniasConnect(e.target.checked);
  };
  const checkUniqueShortkey = async (key) => {
    if (!params.id) {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.company}/companyByShortKey?shortKey=${key}`;
      const result = await OAuthService.getList(url);
      if (result.data) {
        setValidError({
          ...validError,
          shortKey: "This short key is already exist",
        });
      }
    }
  };

  const deleteCustomerVendor = async (index, type) => {
    if (type == "add") {
      const custVend = customerVendor.filter((data, key) => {
        if (key !== index) {
          return data;
        }
      });
      setCustomerVendor(custVend);
    } else if (type == "edit") {
      const saveCustVend = saveCustomerVendor.filter((data, key) => {
        if (key !== index) {
          return data;
        }
      });
      setSaveCustomerVendor(saveCustVend);
      saveCustVend = saveCustVend.map((data, key) => {
        delete data.edit;
        delete data.error;
        return data;
      });
      let model = {
        vendorCustomerRef: saveCustVend,
      };
      try {
        await OAuthService.updateData(url, params.id, model);
      } catch (error) {
        setError(error.message);
      }
    }
  };

  const addEmailRouting = async (data, index, type) => {
    let updatedData;
    if (type === "edit") {
      updatedData = saveEmailRouting.map((data, key) => {
        if (key === index) {
          data.edit = false;
        }
        return data;
      });
      setSaveEmailRouting(updatedData);
      updatedData = updatedData.map((data, key) => {
        delete data.edit;
        delete data?.error;
        return data;
      });
    } else if (type === "add") {
      updatedData = saveEmailRouting
        ? [...saveEmailRouting, { ...data }]
        : [{ ...data }];
      setSaveEmailRouting(
        saveEmailRouting
          ? [...saveEmailRouting, { ...data, edit: false }]
          : [{ ...data, edit: false }]
      );
      updatedData = updatedData.map((data, key) => {
        delete data?.edit;
        delete data?.error;
        return data;
      });
      const routings = emailRouting.filter((data, key) => {
        if (key !== index) {
          return data;
        }
      });
      setEmailRouting(routings);
    }
    let model = {
      emailRoutings: updatedData,
    };

    try {
      if (data) {
        await OAuthService.updateData(url, params.id, model);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const handleAltAddress = async (index, e, name, action) => {
    const address = [...altaddress];
    address[index][e?.target?.name || name] =
      action?.action === "clear" ? "" : e?.target?.value || e.value;
    if (name === "city") {
      const countryChange = await OAuthService.getList(
        `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.cities}/${e.id}/country`
      );
      address[index]["country"] = countryChange?.data?.name;
    }
    setAltAddress(address);
  };

  useEffect(() => {
    if (queryParam.get("tab")) {
      setTabValue(parseInt(queryParam.get("tab"), 10));
    }
  }, [queryParam.get("tab")]);

  const deleteAlternateAddress = (index) => {
    const altadds = altaddress.filter((data, key) => {
      if (key !== index) {
        return data;
      }
    });
    setAltAddress(altadds);
  };

  const onShowroomSelectionChanged = (params) => {
    setSelectedShowroomRows(params.api.getSelectedRows());
  };
  const onEmailSelectionChanged = (params) => {
    setSelectedEmailRows(params.api.getSelectedRows());
  };

  
  const onShowroomRowDoubleClicked = () => {
    var filename = selectedShowroomRows[0]?.id;
    navigate("/editShowroom/" + filename + "?customerId=" + params.id);
  };

  const handleCancel = () => {
    navigate("/partners");
  };
  useEffect(() => {
    if (partnerType === "NOLTEFZE") {
      if (
        partnerType &&
        customerName &&
        shortKey &&
        country &&
        address1 &&
        city &&
        pipelineId &&
        Object.values(validError).filter(
          (o) => o !== null && o !== "" && o !== undefined
        ).length === 0
      ) {
        if(hubspotSupported === true){
          if(pipelineId && hubspotOrderStage){
            if (editData) {
              if (
                editData.customerType !== partnerType ||
                customerName !== editData.name ||
                shortKey !== editData.shortKey ||
                country !== editData.countryName ||
                address1 !== editData.defaultAddress.address1 ||
                city !== editData.defaultAddress.city ||
                editData.emailId !== emailId ||
                // JSON.stringify([...editData?.areaManager|| []].sort()) !== JSON.stringify([...emailIdAm].sort()) ||
                website !== editData.website ||
                territory !== editData.territory ||
                hubspotOrderPlacedStage !== editData.hubspotOrderPlacedStage ||
                hubspotOrderStage !== editData.hubspotOrderStage ||
                pipelineId !== editData.pipelineId ||
                hubspotSupported !== editData.hubspotSupported ||
                (editFinanceData &&
                  JSON.stringify(financeData) !==
                    JSON.stringify(editFinanceData)) ||
                JSON.stringify(budgetCat) !==
                  JSON.stringify(editData.budgetOrderCategoryIds) ||
                  JSON.stringify(currentEmail) !==
                  JSON.stringify(editData.areaManager) ||
                defaultContact !== editData.defaultContact ||
                active !== editData.active ||
                caniasConnect !== editData.caniasConnect ||
                address2 !== editData.defaultAddress.address2 ||
                poBox !== editData.defaultAddress.poBox ||
                JSON.stringify(altaddress) !==
                  JSON.stringify(editData.alternateAddress) ||
                editData.showInMisReport !== showInMisReport
              ) {
                setSaveDisable(false);
              } else {
                setSaveDisable(true);
              }
            } else {
              setSaveDisable(false);
            }
          }else{
            setSaveDisable(true)
          }
        }else{
          if (editData) {
            if (
              editData.customerType !== partnerType ||
              customerName !== editData.name ||
              shortKey !== editData.shortKey ||
              country !== editData.countryName ||
              address1 !== editData.defaultAddress.address1 ||
              city !== editData.defaultAddress.city ||
              editData.emailId !== emailId ||
              // JSON.stringify([...emailIdAm].sort()) !== JSON.stringify([...editData?.areaManager|| []].sort())||
              website !== editData.website ||
              territory !== editData.territory ||
              hubspotOrderPlacedStage !== editData.hubspotOrderPlacedStage ||
              hubspotOrderStage !== editData.hubspotOrderStage ||
              pipelineId !== editData.pipelineId ||
              hubspotSupported !== editData.hubspotSupported ||
              (editFinanceData &&
                JSON.stringify(financeData) !==
                  JSON.stringify(editFinanceData)) ||
              JSON.stringify(budgetCat) !==
                JSON.stringify(editData.budgetOrderCategoryIds) ||
                 JSON.stringify(currentEmail) !==
                  JSON.stringify(editData.areaManager) ||
              defaultContact !== editData.defaultContact ||
              active !== editData.active ||
              caniasConnect !== editData.caniasConnect ||
              address2 !== editData.defaultAddress.address2 ||
              poBox !== editData.defaultAddress.poBox ||
              JSON.stringify(altaddress) !==
                JSON.stringify(editData.alternateAddress) ||
              editData.showInMisReport !== showInMisReport
            ) {
              setSaveDisable(false);
            } else {
              setSaveDisable(true);
            }
          } else {
            setSaveDisable(false);
          }
        }
       
      } else {
        setSaveDisable(true);
      }
    } else {
      if (
        partnerType &&
        customerName &&
        shortKey &&
        country &&
        address1 &&
        city &&
        territory &&
        Object.values(validError).filter(
          (o) => o !== null && o !== "" && o !== undefined
        ).length === 0
      ) {
        if(hubspotSupported === true){
          if(pipelineId && hubspotOrderStage){
        if (editData) {
          if (
            editData.customerType !== partnerType ||
            customerName !== editData.name ||
            shortKey !== editData.shortKey ||
            (editFinanceData &&
              JSON.stringify(financeData) !==
                JSON.stringify(editFinanceData)) ||
            country !== editData.countryName ||
            address1 !== editData.defaultAddress.address1 ||
            city !== editData.defaultAddress.city ||
            editData.emailId !== emailId ||
            // JSON.stringify([...editData?.areaManager|| []].sort())!==JSON.stringify([...emailIdAm]?.sort()) ||
            website !== editData.website ||
            territory !== editData.territory ||
            JSON.stringify(budgetCat) !==
              JSON.stringify(editData.budgetOrderCategoryIds) ||
               JSON.stringify(currentEmail) !==
              JSON.stringify(editData.areaManager) ||
            defaultContact !== editData.defaultContact ||
            active !== editData.active ||
            caniasConnect !== editData.caniasConnect ||
            hubspotOrderPlacedStage !== editData.hubspotOrderPlacedStage ||
            hubspotOrderStage !== editData.hubspotOrderStage ||
            pipelineId !== editData.pipelineId ||
            hubspotSupported !== editData.hubspotSupported ||
            address2 !== editData.defaultAddress.address2 ||
            poBox !== editData.defaultAddress.poBox ||
            JSON.stringify(altaddress) !==
              JSON.stringify(editData.alternateAddress) ||
            editData.showInMisReport !== showInMisReport
          ) {
            setSaveDisable(false);
          } else {
            setSaveDisable(true);
          }
        } else {
          setSaveDisable(false);
        }
      } else {
        setSaveDisable(true);
      }
    }else{
      if (editData) {
        if (
          editData.customerType !== partnerType ||
          customerName !== editData.name ||
          shortKey !== editData.shortKey ||
          (editFinanceData &&
            JSON.stringify(financeData) !==
              JSON.stringify(editFinanceData)) ||
          country !== editData.countryName ||
          address1 !== editData.defaultAddress.address1 ||
          city !== editData.defaultAddress.city ||
          editData.emailId !== emailId ||
          // JSON.stringify([...editData?.areaManager|| []].sort())!==JSON.stringify([...emailIdAm]?.sort())||
          website !== editData.website ||
          territory !== editData.territory ||
          JSON.stringify(budgetCat) !==
            JSON.stringify(editData.budgetOrderCategoryIds) ||
             JSON.stringify(currentEmail) !==
            JSON.stringify(editData.areaManager) ||
          defaultContact !== editData.defaultContact ||
          active !== editData.active ||
          caniasConnect !== editData.caniasConnect ||
          hubspotOrderPlacedStage !== editData.hubspotOrderPlacedStage ||
          hubspotOrderStage !== editData.hubspotOrderStage ||
          pipelineId !== editData.pipelineId ||
          hubspotSupported !== editData.hubspotSupported ||
          address2 !== editData.defaultAddress.address2 ||
          poBox !== editData.defaultAddress.poBox ||
          JSON.stringify(altaddress) !==
            JSON.stringify(editData.alternateAddress) ||
          editData.showInMisReport !== showInMisReport
        ) {
          setSaveDisable(false);
        } else {
          setSaveDisable(true);
        }
      } else {
        setSaveDisable(false);
      }
    }
      } else {
        setSaveDisable(true);
      }
    }
  }, [
    partnerType,
    financeData,
    customerName,
    shortKey,
    country,
    address1,
    city,
    emailId,
    currentEmail,
    website,
    territory,
    hubspotSupported,
    hubspotOrderPlacedStage,
    hubspotOrderStage,
    pipelineId,
    budgetCat,
    defaultContact,
    active,
    caniasConnect,
    address2,
    poBox,
    showInMisReport,
    altaddress,
    validError,
  ]);

  const setAllSuccessMsg = (msg, tab) => {
    if (tab === tabValue) {
      setSuccessMsg(msg);
      if (msg) {
        setSnackState(true);
      } else {
        setSnackState(false);
      }
    }
    if (tab === 5) {
      if (msg) {
        setDiscountSuccessMsg(msg);
      }
    } else if (tab === 6) {
      if (msg) {
        setFinanceSuccessMsg(msg);
      }
    } else if (tab === 7) {
      if (msg) {
        setDocumentSuccessMsg(msg);
      }
    }
  };

  const setAllErrorMsg = (msg, tab) => {
    if (tab === tabValue) {
      setError(msg);
    }
    if (tab === 5) {
      setDiscountError(msg);
    } else if (tab === 6) {
      setFinanceError(msg);
    } else if (tab === 7) {
      setDocumentError(msg);
    } else if (tab === 3) {
      setCustomerError(msg);
    }
  };
const getAllHubspotDeals = async () => {
  const hubspotList = await OAuthService.getList(hubspotUrl);

  setHubspotData(hubspotList.data.results);

  setPipelineOptions(
    hubspotList.data.results.map((pipeline) => ({
      value: pipeline.id,
      label: pipeline.label,
    }))
  );
};
useEffect(() => {
  if (pipelineId && hubspotData?.length) {
    const selectedPipeline = hubspotData.find(
      (p) => p.id === pipelineId
    );

    if (selectedPipeline?.stages) {
      setStageOptions(
        selectedPipeline.stages.map((stage) => ({
          value: stage.id,
          label: stage.label,
        }))
      );
    } else {
      setStageOptions([]);
    }
  }
}, [pipelineId, hubspotData]);
useEffect(() => {
if(hubspotSupported){
  getAllHubspotDeals();
}
}, [hubspotSupported])

  useEffect(() => {
    setAllSuccessMsg();
    setAllErrorMsg();
  }, [customerSuccessMsg, tabValue, successMsg]);

  useEffect(() => {
    if (tabValue === 5) {
      discountError ? setError(discountError) : setError("");
      if (discountSuccessMsg) {
        setSuccessMsg(discountSuccessMsg);
        setSnackState(true);
      }
    } else if (tabValue === 6) {
      financeError ? setError(financeError) : setError("");
      if (financeSuccessMsg) {
        setSuccessMsg(financeSuccessMsg);
        setSnackState(true);
      }
    } else if (tabValue === 7) {
      documentError ? setError(documentError) : setError("");
      if (documentSuccessMsg) {
        setSuccessMsg(documentSuccessMsg);
        setSnackState(true);
      }
    } else if (tabValue === 3) {
      customerError ? setError(customerError) : setError("");
      if (customerSuccessMsg) {
        setSuccessMsg(customerSuccessMsg);
        setSnackState(true);
      }
    } else {
      setError("");
      setSuccessMsg("");
    }
  }, [
    tabValue,
    documentSuccessMsg,
    financeSuccessMsg,
    discountSuccessMsg,
    customerSuccessMsg,
  ]);

  const address =
    address1 && address2
      ? city
        ? address1 + " " + address2 + " " + city
        : address1 + " " + address2
      : address1;

  const handleReportChange = (e) => {
    setShowInMisReport(e.target.checked);
  };
  const handleHubSpot = (e) => {
    setHubspotSupported(e.target.checked);
  };

  return (
    <div className="w-full h-full overflow-scroll">
      <Backdrop
        open={loading || saving}
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <FormPageHeader
        componentName="Partner"
        handleDelete={handleDelete}
        handleSubmit={handleSubmit}
        breadCrumbSeperator=">"
        currentPage={params.id ? "Update Partner" : "Add Partner"}
        parentBreadcrumbData={[
          { pageName: "Partner List", pageLink: "/partners" },
        ]}
        error={error}
        successMsg={successMsg}
        snackState={snackState}
        hideDelete={hideDelete || isIamOnly}
        saveDisable={saveDisable}
        handleCancel={handleCancel}
      >
       <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}
        >
          <Tab 
            label="General" 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          {params.id && partnerType !== "NOLTEFZE" && (
            <Tab 
              label="Showroom" 
              sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
            />
          )}
          {params.id && (
            <Tab 
              label="Emails" 
              sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
            />
          )}
          {params.id && partnerType !== "NOLTEFZE" && (
            <Tab 
              label="Customer Vendor Relation" 
              sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
            />
          )}
          {params.id && (
            <Tab 
              label="User" 
              sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
            />
          )}
          {params.id && partnerType !== "NOLTEFZE" && (
            <Tab 
              label="Discount" 
              sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
            />
          )}
          {/* {params.id && partnerType === "NOLTEFZE" && <Tab label="Finance" />} */}
          {params.id &&
            (!token?.scope.includes("ROLE_IAM") ||
              token?.scope.includes("ROLE_ADMIN") ||
              token?.scope.includes("ROLE_SOPDIR")) && (
                <Tab 
                  label="Finance" 
                  sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
                />
            )}
          {params.id &&
            (!token?.scope.includes("ROLE_IAM") ||
              token?.scope.includes("ROLE_ADMIN") ||
              token?.scope.includes("ROLE_SOPDIR")) && (
                <Tab 
                  label="Document" 
                  sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
                />
            )}
          {/* <Tab label="Budget" /> */}
        </Tabs>
      </FormPageHeader>
      <div className="p-16 sm:p-24">
        <FormControl ref={formRef} className="flex flex-col justify-top h-full">
          <div className={tabValue !== 0 ? "hidden" : ""}>
            <Grid container spacing={2}>
              <Grid xs={6} item>
                <Box
                  className="mb-20 mt-20"
                  sx={{ p: 2, border: "1px dashed grey" }}
                >
                  <Stack className="mb-16">
                    <label><span className="text-[#f44336]">*</span>Select Partner Type</label>
                    <Select
                      name="partnerType"
                      value={
                        partnerType &&
                        parterOptions &&
                        parterOptions.filter((obj) => partnerType === obj.value)
                      }
                      onChange={handlePartnerChange}
                      options={parterOptions}
                      styles={customStyles(
                        ((checksubmit && !partnerType) ||
                          validError.partnerType) &&
                          "#f44336",
                      )}
                      isDisabled={
                        params.id &&
                        !token?.scope.includes("ROLE_ADMIN") &&
                        !token?.scope.includes("ROLE_MD")
                          ? true
                          : false
                      }
                      className="select"
                    />
                    <Typography className="text-[#f44336] text-sm ml-14">
                      {checksubmit && !partnerType
                        ? "This field is required"
                        : validError.partnerType}
                    </Typography>
                  </Stack>
                  <Stack>
                    <label><span className="text-[#f44336]">*</span>Partner Name</label>
                    <TextField
                      className="mb-16"
                      type="text"
                      error={
                        (checksubmit && !customerName) ||
                        validError.customerName
                          ? true
                          : false
                      }
                      name="customerName"
                      value={customerName}
                      onChange={(e) => {
                        setCustomerName(e.target.value.toUpperCase());
                        // setValidError({
                        //   ...validError,
                        //   customerName: e.target.value,
                        // });
                      }}
                      helperText={
                        checksubmit && !customerName
                          ? "This field is required"
                          : validError.customerName
                      }
                      variant="outlined"
                      InputLabelProps={{
                        shrink: customerName ? true : false,
                      }}
                    />
                  </Stack>
                  <Stack>
                    <label>Partner Number</label>
                    <TextField
                      className="mb-16"
                      type="text"
                      error={
                        (checksubmit && !customerNumber) ||
                        validError.customerNumber
                          ? true
                          : false
                      }
                      name="customerNumber"
                      value={customerNumber}
                      onChange={(e) => setCustomerNumber(e.target.value)}
                      disabled
                      variant="outlined"
                      InputLabelProps={{
                        shrink: customerNumber ? true : false,
                      }}
                    />
                  </Stack>
                  <Stack>
                    <label>Email Id</label>
                    <TextField
                      className="mb-16"
                      type="text"
                      error={validError.email ? true : false}
                      value={emailId}
                      name="emailId"
                      onChange={(e) => {
                        setEmailId(e.target.value);
                        setValidError({
                          ...validError,
                          email:
                            e.target.value && emailValidation(e.target.value),
                        });
                      }}
                      variant="outlined"
                      helperText={validError.email}
                      InputLabelProps={{
                        shrink: emailId ? true : false,
                      }}
                    />
                  </Stack>
                  <Stack>
                    <label>Website</label>
                    <TextField
                      className="mb-16"
                      type="text"
                      error={validError.website ? true : false}
                      value={website}
                      name="website"
                      onChange={(e) => {
                        setWebsite(e.target.value);
                        setValidError({
                          ...validError,
                          website: e.target.value && isUrlValid(e.target.value),
                        });
                      }}
                      variant="outlined"
                      helperText={validError.website}
                      InputLabelProps={{
                        shrink: website ? true : false,
                      }}
                    />
                  </Stack>
                  <Stack>
                    <label>Telephone</label>
                    <TextField
                      className="mb-16"
                      name="telephone"
                      onChange={(e) =>
                        handleFinanceDataChange("telephone", e.target.value)
                      }
                      value={financeData.telephone}
                      error={validError.phoneNumber ? true : false}
                      onKeyUp={(e) =>
                        setValidError({
                          ...validError,
                          phoneNumber:
                            e.target.value && checkPhoneNumber(e.target.value),
                        })
                      }
                      helperText={validError?.phoneNumber}
                    />
                  </Stack>
                  <Stack>
                    <label>Fax</label>
                    <TextField
                      name="fax"
                      value={financeData.fax}
                      error={validError.faxNumber ? true : false}
                      onKeyUp={(e) =>
                        setValidError({
                          ...validError,
                          faxNumber:
                            e.target.value && checkFaxNumber(e.target.value),
                        })
                      }
                      helperText={validError?.faxNumber}
                      onChange={(e) =>
                        handleFinanceDataChange("fax", e.target.value)
                      }
                    />
                  </Stack>
                </Box>
                <Box
                  className="mb-20 mt-20"
                  sx={{ p: 2, border: "1px dashed grey" }}
                >
                  <Stack spacing={2}>
                    <label>Area Manager Details</label>
                    <Select
                      name="currentEmail"
                      value={
                        allUserList &&
                        currentEmail &&
                        allUserList.filter((obj) =>
                          currentEmail.includes(obj.value),
                        )
                      }
                      onChange={handleAreaManagerEmailChange}
                      isMulti
                      className="select"
                      classNamePrefix="select"
                      options={allUserList}
                      styles={customStyles()}
                    />
                  </Stack>
                </Box>
              </Grid>
              <Grid xs={6} item>
                <Box
                  className="mb-20 mt-20"
                  sx={{ p: 2, border: "1px dashed grey" }}
                >
                  <Stack>
                    <label><span className="text-[#f44336]">*</span>Short Key</label>
                    <TextField
                      className="mb-16"
                      type="text"
                      name="shortKey"
                      error={
                        (checksubmit && !shortKey) || validError?.shortKey
                          ? true
                          : false
                      }
                      value={shortKey}
                      required
                      onChange={(e) => {
                        setShortKey(e.target.value);
                        setValidError({
                          ...validError,
                          shortKey: checkShortKey(e.target.value),
                        });
                      }}
                      helperText={
                        checksubmit && !shortKey
                          ? "This field is required"
                          : validError?.shortKey
                      }
                      onBlur={(e) => checkUniqueShortkey(e.target.value)}
                      variant="outlined"
                      inputProps={{
                        maxLength: 2,
                      }}
                      InputLabelProps={{
                        shrink: shortKey ? true : false,
                      }}
                    />
                  </Stack>
                  <Stack className="mb-16">
                    <label>
                      {partnerType !== "NOLTEFZE" && <span className="text-[#f44336]">*</span>}Select Territory
                    </label>
                    <Select
                      name="territory"
                      value={
                        territory &&
                        territoryOptions &&
                        territoryOptions.filter((obj) => territory === obj.id)
                      }
                      onChange={handleTerritoryChange}
                      options={territoryOptions}
                      styles={customStyles()}
                      className="select"
                      isClearable={partnerType === "NOLTEFZE"}
                    />
                    {/* <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !territory) ? "This field is required" : validError.territory}</Typography> */}
                  </Stack>
                  <Stack className="mb-16">
                    <label><span className="text-[#f44336]">*</span>Select Country</label>
                    <Select
                      name="country"
                      value={
                        country &&
                        countryOptions &&
                        countryOptions.filter((obj) =>
                          country.includes(obj.value),
                        )
                      }
                      onChange={handleCountryChange}
                      options={countryOptions}
                      styles={customStyles(
                        ((checksubmit && !country) || validError.country) &&
                          "#f44336",
                      )}
                      className="select"
                      getOptionLabel={(e) => (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {e.icon}
                          <span style={{ marginLeft: 5 }}>{e.label}</span>
                        </div>
                      )}
                    />
                    <Typography className="text-[#f44336] text-sm ml-14">
                      {checksubmit && !country
                        ? "This field is required"
                        : validError.country}
                    </Typography>
                  </Stack>
                  <Stack className="mb-16">
                    <label>Select Budget Category</label>
                    <Select
                      name="budgetCat"
                      value={
                        orderTypeOptions &&
                        budgetCat &&
                        orderTypeOptions.filter((obj) =>
                          budgetCat.includes(obj.value),
                        )
                      }
                      onChange={handleBudgetCatChange}
                      isMulti
                      className="select"
                      classNamePrefix="select"
                      options={orderTypeOptions}
                      styles={customStyles()}
                    />
                    {/* <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !budgetCat) ? "This field is required" : validError.budgetCat}</Typography> */}
                  </Stack>
                  <Stack className="mb-16">
                    <label>Default Contact</label>
                    <Select
                      name="defaultContact"
                      value={
                        defaultContact &&
                        userOptions &&
                        userOptions.filter((obj) =>
                          defaultContact.includes(obj.value),
                        )
                      }
                      onChange={handleDefaultContact}
                      className="select"
                      classNamePrefix="select"
                      options={userOptions}
                      styles={customStyles()}
                      isClearable
                    />
                    {/* <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !defaultContact) ? "This field is required" : validError.defaultContact}</Typography> */}
                  </Stack>
                  <Stack className="mb-16">
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={hubspotSupported}
                            onChange={handleHubSpot}
                          />
                        }
                        label="Hubspot Support"
                      />
                    </FormGroup>
                  </Stack>
                  {hubspotSupported && (
                    <Stack direction={"row"} className="flex justify-between gap-16">
                      {hubspotSupported ? (
                        <>
                          <Stack className="mb-8">
                            <label><span className="text-[#f44336]">*</span>Pipeline ID</label>
                            <Select
                              label="*Pipeline ID"
                              className="mb-16  "
                              type="text"
                              error={
                                (checksubmit && !pipelineId) ||
                                validError.pipelineId
                                  ? true
                                  : false
                              }
                              name="pipelineId"
                              value={
                                pipelineOptions &&
                                pipelineOptions.find(
                                  (obj) => obj.value === pipelineId,
                                )
                              }
                              options={pipelineOptions}
                              styles={customStyles()}
                              onChange={(e) => {
                                setPipelineId(e.value);
                               
                              }}
                              helperText={
                                checksubmit && !pipelineId
                                  ? "This field is required"
                                  : validError.pipelineId
                              }
                            />
                          </Stack>

                          <Stack className="mb-8">
                             <label><span className="text-[#f44336]">*</span>Hubspot Order Stage</label>
                            <Select
                              label="*Hubspot Order Stage"
                              className="mb-16 "
                              name="hubspotOrderStage"
                              value={stageOptions.find(
                                (opt) => opt.value === hubspotOrderStage,
                              )}
                              options={stageOptions}
                              styles={customStyles()}
                              onChange={(e) => {
                                setHubspotOrderStage(e.value);
                                
                              }}
                              placeholder="Select Stage"
                            />
                          </Stack>
                        </>
                      ) : (
                        <div>
                          <TextField
                            label="Pipeline Id"
                            className="mb-16 "
                            type="text"
                            name="pipelineId"
                            value={pipelineId}
                            onChange={(e) => {
                              setPipelineId(e.target.value);
                            }}
                            variant="outlined"
                            InputLabelProps={{
                              shrink: pipelineId ? true : false,
                            }}
                          />
                        </div>
                      )}
                      <Stack className="mb-8">
                             <label>Hubspot Order Placed Stage</label>
                        <Select
                          label="Hubspot Order Placed Stage"
                          className="mb-16 "
                          name="hubspotOrderPlacedStage"
                          value={stageOptions.find(
                            (opt) => opt.value === hubspotOrderPlacedStage,
                          )}
                          options={stageOptions}
                          styles={customStyles()}
                          onChange={(e) => {
                            setHubspotOrderPlacedStage(e.value);
                          }}
                          placeholder="Select Stage"
                        />
                      </Stack>
                    </Stack>
                  )}

                  {/* <Stack>
                            <Select name="altContact"
                                value={(altContact && userOptions) && userOptions.filter(obj => altContact.includes(obj.value))}
                                onChange={handleAltContact}
                                className="select"
                                classNamePrefix="select"
                                options={userOptions}
                                styles={customStyles()}
                            />
                        </Stack> */}
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={caniasConnect}
                          onChange={handleCaniasConnectChange}
                        />
                      }
                      label="Connect with Canias"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={active}
                          onChange={handleActiveChange}
                        />
                      }
                      label="Active"
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={showInMisReport}
                          onChange={handleReportChange}
                        />
                      }
                      label="Show In Mis Report"
                    />
                  </FormGroup>
                </Box>
                <Box
                  className="mb-20 mt-20"
                  sx={{ p: 2, border: "1px dashed grey" }}
                >
                  <Stack spacing={2}>
                    <label>Home currency</label>
                    <Stack>
                      <label>Currency</label>
                      <Select
                        value={
                          financeData.symbol &&
                          currencyList &&
                          currencyList.filter(
                            (list) => list.value === financeData.symbol,
                          )
                        }
                        options={currencyList}
                        onChange={onSelectCurrency}
                        styles={customStyles()}
                        isClearable
                      ></Select>
                    </Stack>
                    <Stack>
                      <label>Symbol</label>
                      <TextField
                        name={"symbol"}
                        value={financeData.symbol}
                        disabled
                        onChange={(e) =>
                          handleFinanceDataChange("symbol", e.target.value)
                        }
                      />
                    </Stack>
                  </Stack>
                </Box>
              </Grid>
            </Grid>

            <Box
              className="mb-20 mt-20"
              sx={{ p: 2, border: "1px dashed grey" }}
            >
              <Stack>
                <label className="mb-16">Default Address</label>
                <label><span className="text-[#f44336]">*</span>Address 1</label>
                <TextField
                  className="mb-16"
                  type="text"
                  name="address1"
                  error={
                    (checksubmit && !address1) || validError.address1
                      ? true
                      : false
                  }
                  value={address1}
                  required
                  onChange={(e) => {
                    setAddress1(e.target.value);
                  }}
                  helperText={
                    checksubmit && !address1
                      ? "This field is required"
                      : validError.address1
                  }
                  variant="outlined"
                  InputLabelProps={{
                    shrink: address1 ? true : false,
                  }}
                />
                <label>Address 2</label>
                <TextField
                  className="mb-16"
                  type="text"
                  name="address2"
                  error={validError.address2 ? true : false}
                  value={address2}
                  required
                  onChange={(e) => {
                    setAddress2(e.target.value);
                  }}
                  helperText={validError.address2}
                  variant="outlined"
                />
                <Stack className="mb-16">
                  <label><span className="text-[#f44336]">*</span>Select City</label>
                  <Select
                    name="city"
                    value={
                      cityOptions &&
                      city &&
                      cityOptions.filter((obj) => city.includes(obj.value))
                    }
                    onChange={handleAddCityChange}
                    className="select"
                    classNamePrefix="select"
                    options={cityOptions}
                    styles={customStyles(
                      ((checksubmit && !city) || validError.city) && "#f44336",
                    )}
                  />
                  <Typography className="text-[#f44336] text-sm ml-14">
                    {checksubmit && !city
                      ? "This field is required"
                      : validError.city}
                  </Typography>
                </Stack>
                <label>PO Box</label>
                <TextField
                  className="mb-16"
                  type="text"
                  name="poBox"
                  error={validError.poBox ? true : false}
                  value={poBox}
                  required
                  onChange={(e) => {
                    setPoBox(e.target.value);
                  }}
                  helperText={validError.poBox}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: poBox ? true : false,
                  }}
                />
                {/* <Stack className="mb-16">
                                    <Select name="addcountryName"
                                        value={countryOptions && addcountryName && countryOptions.filter(obj => addcountryName.includes(obj.value))}
                                        onChange={handleAddCountryChange}
                                        className="select"
                                        classNamePrefix="select"
                                        options={countryOptions}
                                        styles={customStyles(((checksubmit && !addcountryName) || validError.addcountryName) && "#f44336")}
                                        getOptionLabel={e => (
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                {e.icon}
                                                <span style={{ marginLeft: 5 }}>{e.label}</span>
                                            </div>
                                        )}
                                    />
                                    <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !addcountryName) ? "This field is required" : validError.addcountryName}</Typography>
                                </Stack> */}
              </Stack>
            </Box>
            {((addCount > 0 && altaddress) ||
              (params.id && altaddress !== null)) &&
              altaddress.map((element, index) => {
                return (
                  <Box
                    className="mb-20 mt-20"
                    sx={{ p: 2, border: "1px dashed grey" }}
                  >
                    <Stack>
                      <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={(e) => {
                            deleteAlternateAddress(index);
                          }}
                        >
                          <FuseSvgIcon>heroicons-solid:trash</FuseSvgIcon>
                        </Button>
                      </div>

                      <lable className="mb-16">Alternate Address</lable>
                      <label>Address 1</label>
                      <TextField
                        className="mb-16"
                        type="text"
                        name="address1"
                        value={element.address1}
                        required
                        onChange={(e) => handleAltAddress(index, e)}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: element.address1 ? true : false,
                        }}
                      />
                      <label>Address 2</label>
                      <TextField
                        className="mb-16"
                        type="text"
                        name="address2"
                        value={element.address2}
                        required
                        onChange={(e) => handleAltAddress(index, e)}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: element.address2 ? true : false,
                        }}
                      />
                      <label>Select City</label>
                      <Select
                        name="city"
                        value={
                          cityOptions &&
                          element.city &&
                          cityOptions.filter((obj) =>
                            element.city.includes(obj.value),
                          )
                        }
                        onChange={(e, action) =>
                          handleAltAddress(index, e, "city", action)
                        }
                        className="select mb-16"
                        classNamePrefix="select"
                        options={cityOptions}
                        styles={customStyles()}
                        isClearable
                      />
                      <label>Po Box</label>
                      <TextField
                        className="mb-16"
                        type="text"
                        name="poBox"
                        value={element.poBox}
                        required
                        onChange={(e) => handleAltAddress(index, e)}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: element.poBox ? true : false,
                        }}
                      />
                      {/* <Stack>
                                        <Select name="country"
                                            value={(altaddress && countryOptions) && countryOptions.filter(obj => element.country.includes(obj.value))}
                                            onChange={(e) => handleAltAddress(index, e, "country")}
                                            className="select mb-16"
                                            classNamePrefix="select"
                                            options={countryOptions}
                                            getOptionLabel={e => (
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    {e.icon}
                                                    <span style={{ marginLeft: 5 }}>{e.label}</span>
                                                </div>
                                            )}
                                            styles={customStyles()}
                                        />
                                    </Stack> */}
                    </Stack>
                  </Box>
                );
              })}
            <Stack className="mb-10">
              <Button
                variant="contained"
                color="secondary"
                onClick={() => {
                  setAddCount(addCount + 1);
                  setAltAddress(
                    altaddress
                      ? [
                          ...altaddress,
                          {
                            poBox: "",
                            address1: "",
                            address2: "",
                            city: "",
                            country: "",
                          },
                        ]
                      : [
                          {
                            poBox: "",
                            address1: "",
                            address2: "",
                            city: "",
                            country: "",
                          },
                        ],
                  );
                }}
              >
                Add Alternate Address
              </Button>
            </Stack>
          </div>

          <div
            className={
              partnerType !== "NOLTEFZE"
                ? tabValue !== 1
                  ? "hidden"
                  : "h-full"
                : "hidden"
            }
          >
            <Grid
              className="flex flex-row mb-10"
              justifyContent="flex-end"
              alignItems="flex-end"
            >
              <Button
                variant="contained"
                color="secondary"
                startIcon={<AddCircleOutlineIcon />}
                onClick={(e) => navigate("/addShowroom?customerId=" + params.id)}
              >
                Add Showroom
              </Button>
            </Grid>
            <Stack style={{ height: "500px" }}>
              <AgGridTable
                rowData={rowDataShowroom}
                columnDefs={columnDefsShowroom}
                onGridReady={onGridShowroomReady}
                onSelectionChanged={onShowroomSelectionChanged}
                onRowDoubleClicked={onShowroomRowDoubleClicked}
                saveGridStateName={"customersShowroomList"}
              />
            </Stack>
          </div>

          <div
            className={
              partnerType !== "NOLTEFZE"
                ? tabValue !== 2
                  ? "hidden"
                  : "h-full"
                : tabValue !== 1
                ? "hidden"
                : "h-full"
            }
          >
            {(!token?.scope.includes("ROLE_IAM") ||
              token?.scope.includes("ROLE_ADMIN") ||
              token?.scope.includes("ROLE_SOPDIR")) && (
              <>
                <Button
                  className="mb-10 float-right"
                  variant="contained"
                  color="secondary"
                  disabled={selectedEmailRows.length <= 0}
                  onClick={() => runSaving(async () => {
                    if (
                      emailRouting?.some(
                        (obj) =>
                          obj.emailRouting === "" ||
                          // obj.from === "" ||
                          // obj.to === "" ||
                          // obj.to === [] ||
                          obj.cc === "" ||
                          obj.cc === [],
                      )
                    ) {
                      const routing = emailRouting.filter(
                        (item) =>
                          !selectedEmailRows.some(
                            (ftItem) => ftItem.id === item.id,
                          ),
                      );
                      setEmailRouting(routing);
                      setSavedEmailRouting(routing);
                      setSelectedEmailRows([]);
                    } else {
                      const routing = emailRouting.filter(
                        (item) =>
                          !selectedEmailRows.some(
                            (ftItem) => ftItem.id === item.id,
                          ),
                      );
                      let model = {
                        emailRoutings: routing,
                      };
                      setEmailRouting(routing);
                      setSavedEmailRouting(routing);
                      try {
                        await OAuthService.updateData(url, params.id, model);
                        await editPartner();
                        setSelectedEmailRows([]);
                        setSavedEmailData(routing);
                        toast.success("Routing deleted successfully");
                      } catch (error) {
                        setError(error.message);
                      }
                    }
                  })}
                >
                  <FuseSvgIcon>heroicons-solid:trash</FuseSvgIcon>
                </Button>

                <Button
                  className="mb-10 mr-10 float-right"
                  variant="contained"
                  color="secondary"
                  // disabled={saveEnableDisable || selectedEmailRows?.length > 0}
                  onClick={handleEmailSave}
                >
                  <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
                </Button>

                <Button
                  className="mb-10 mr-10 float-right"
                  variant="contained"
                  color="secondary"
                  disabled={selectedEmailRows?.length > 0}
                  onClick={() => {
                    setEmailCount(emailCount + 1);
                    setEmailRouting(
                      emailRouting
                        ? [
                            ...emailRouting,
                            {
                              id:
                                emailRouting[emailRouting?.length - 1]?.id ===
                                undefined
                                  ? emailRouting?.length + 1
                                  : emailRouting[emailRouting?.length - 1]?.id +
                                    1,
                              emailRouting: "",
                              // from: "",
                              // to: "",
                              cc: "",
                            },
                          ]
                        : [{ id: 0, emailRouting: "", cc: "" }],
                    );
                    setSaveOldEditData(
                      JSON.parse(JSON.stringify(emailRouting)),
                    );
                  }}
                >
                  Add Routing
                </Button>
              </>
            )}

            <Stack style={{ height: "500px", width: "100%" }}>
              <AgGridTable
                columnDefs={columnDefsEmail}
                onGridReady={onGridReady}
                gridRef={gridRef}
                rowData={emailRouting}
                // getContextMenuItems={getContextMenuItems}
                onSelectionChanged={onEmailSelectionChanged}
                // onRowDoubleClicked={onRowDoubleClicked}
              />
            </Stack>
          </div>

          <div
            className={
              partnerType !== "NOLTEFZE"
                ? tabValue !== 3
                  ? "hidden"
                  : ""
                : "hidden"
            }
          >
            {saveCustomerVendor && (
              <CustomerVendorRelation
                saveCustomerVendor={saveCustomerVendor}
                hasIamRole={
                  token?.scope.includes("ROLE_IAM") &&
                  !(
                    token?.scope?.includes("ROLE_ADMIN") ||
                    token?.scope?.includes("ROLE_SOPDIR")
                  )
                }
                // setAllSuccessMsg={(msg) => setAllSuccessMsg(msg, 3)}
                setAllSuccessMsg={(msg) =>
                  setAllSuccessMsg(msg, partnerType !== "NOLTEFZE" ? 3 : "")
                }
                // setAllErrorMsg={(msg) => setAllErrorMsg(msg, 3)}
                setAllErrorMsg={(msg) =>
                  setAllErrorMsg(msg, partnerType !== "NOLTEFZE" ? 3 : "")
                }
              />
            )}
          </div>

          <div
            className={
              partnerType !== "NOLTEFZE"
                ? tabValue !== 4
                  ? "hidden"
                  : "h-full"
                : tabValue !== 2
                ? "hidden"
                : "h-full"
            }
          >
            <Grid
              className="flex flex-row mb-10"
              justifyContent="flex-end"
              alignItems="flex-end"
            >
              <Button
                variant="contained"
                color="secondary"
                startIcon={<AddCircleOutlineIcon />}
                onClick={(e) => navigate("/addUser?customerId=" + params.id)}
              >
                Add User
              </Button>
            </Grid>
            <Stack style={{ height: "500px" }}>
              <AgGridTable
                rowData={rowData}
                columnDefs={columnDefs}
                onGridReady={onGridReady}
                saveGridStateName={"customersUserList"}
              />
            </Stack>
          </div>

          <div
            className={
              partnerType !== "NOLTEFZE"
                ? tabValue !== 5
                  ? "hidden"
                  : "h-full"
                : "hidden"
            }
          >
            {params.id && (
              <CustomerDiscountData
                custNum={params.id}
                custName={customerName}
                setAllSuccessMsg={(msg) => setAllSuccessMsg(msg, 5)}
                setAllErrorMsg={(msg) => setAllErrorMsg(msg, 5)}
              />
            )}
          </div>
          {(!token?.scope.includes("ROLE_IAM") ||
            token?.scope.includes("ROLE_ADMIN") ||
            token?.scope.includes("ROLE_SOPDIR")) && (
            <div
              className={
                partnerType !== "NOLTEFZE"
                  ? tabValue !== 6
                    ? "hidden"
                    : "h-full"
                  : tabValue !== 3
                  ? "hidden"
                  : "h-full"
              }
            >
              <FinanceTab
                companyCode={customerNumber}
                companyName={customerName}
                country={country}
                email={emailId}
                website={website}
                address={address}
                setAllSuccessMsg={(msg) =>
                  // setAllSuccessMsg(msg, 3)
                  setAllSuccessMsg(msg, partnerType !== "NOLTEFZE" ? 6 : 3)
                }
                setAllErrorMsg={(msg) =>
                  // setAllErrorMsg(msg, 3)
                  setAllErrorMsg(msg, partnerType !== "NOLTEFZE" ? 6 : 3)
                }
              />
            </div>
          )}
          {(!token?.scope.includes("ROLE_IAM") ||
            token?.scope.includes("ROLE_ADMIN") ||
            token?.scope.includes("ROLE_SOPDIR")) && (
            <div
              className={
                partnerType !== "NOLTEFZE"
                  ? tabValue !== 7
                    ? "hidden"
                    : "h-full"
                  : tabValue !== 4
                  ? "hidden"
                  : "h-full"
              }
            >
              <DocumentTab
                companyCode={customerNumber}
                companyName={customerName}
                country={country}
                email={emailId}
                website={website}
                setAllSuccessMsg={(msg) =>
                  setAllSuccessMsg(msg, partnerType !== "NOLTEFZE" ? 7 : 4)
                }
                setAllErrorMsg={(msg) =>
                  setAllErrorMsg(msg, partnerType !== "NOLTEFZE" ? 7 : 4)
                }
              />
            </div>
          )}
        </FormControl>
      </div>
    </div>
  );
};

export default CustomerForm;
